// extracted by mini-css-extract-plugin
export var attachmentContainer = "_l6-0";
export var fileList = "_l6-2";
export var removeFileButton = "_l6-1";